import React from 'react';
import { Portal } from '@fiverr-private/ui_utils';
import LightboxBackdrop from './LightboxBackdrop';
import { LightboxContextProvider } from './LightboxContext';
import { DEFAULT_ITEMS_COUNT_TO_PRELOAD } from './constants';
import { LightboxProps } from './types';

const Lightbox = ({
  children,
  initialSilentMode = true,
  sources = [],
  sourceInitialIndex = 0,
  onClickNext,
  onClickPrev,
  onClose,
  itemsToPreload = DEFAULT_ITEMS_COUNT_TO_PRELOAD,
  overlayTestId,
}: LightboxProps) => (
  <Portal>
    <LightboxContextProvider
      initialSilentMode={initialSilentMode}
      sourceInitialIndex={sourceInitialIndex}
      sources={sources}
      onClickNext={onClickNext}
      onClickPrev={onClickPrev}
      onClose={onClose}
      itemsToPreload={itemsToPreload}
    >
      <LightboxBackdrop overlayTestId={overlayTestId}>{children}</LightboxBackdrop>
    </LightboxContextProvider>
  </Portal>
);

Lightbox.displayName = 'Lightbox';

export default Lightbox;
